import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-sales-request-ok-dialog',
    templateUrl: './sales-request-ok-dialog.html'
})
export class SalesRequestOkDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<SalesRequestOkDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/sales-request-ok-dialog/sales-request-ok-dialog.ts